import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FilterPipe} from './filter.pipe';
import {WeightMalnutritionLevelPipe} from './weight-malnutrition-level.pipe';
import {HeightMalnutritionLevelPipe} from './height-malnutrition-level.pipe';
import {MuacMalnutritionLevelPipe} from './muac-malnutrition-level.pipe';
import {IMCMalnutritionLevelPipe} from './imc-malnutrition-level.pipe';
import {HeightWeightMalnutritionLevel} from './height-weight-malnutrition-level.pipe';
import {CentimeterToMeterPipe} from './centimeter-to-meter.pipe';

@NgModule({
    declarations: [
        FilterPipe,
        WeightMalnutritionLevelPipe,
        HeightMalnutritionLevelPipe,
        MuacMalnutritionLevelPipe,
        IMCMalnutritionLevelPipe,
        CentimeterToMeterPipe,
        HeightWeightMalnutritionLevel
    ],
    imports: [
        CommonModule
    ], exports: [
        FilterPipe,
        WeightMalnutritionLevelPipe,
        HeightMalnutritionLevelPipe,
        MuacMalnutritionLevelPipe,
        IMCMalnutritionLevelPipe,
        HeightWeightMalnutritionLevel,
        CentimeterToMeterPipe
    ]
})
export class PipeModule {
}
